(() => {
  const palette = {Stock:'#ddd',Green:'#155b32',Red:'#aa0000',Blue:'#0048a8',Black:'#151515',Purple:'#7535a5',Gray:'#73777b'};
  async function mount(root) {
    if (root.dataset.mounted) return;
    root.dataset.mounted = 'true';
    const form = root.querySelector('form'), button = root.querySelector('[data-warren-submit]'), error = root.querySelector('[data-warren-error]');
    const report = message => { error.textContent = message; error.hidden = false; };
    try {
      const response = await fetch(root.dataset.configUrl);
      if (!response.ok) throw new Error('Configuration could not be loaded. Please refresh or contact PSC.');
      const catalog = await response.json(), config = catalog[root.dataset.handle];
      if (!config) throw new Error('Please contact PSC to confirm this transmission configuration.');
      const variants = JSON.parse(root.querySelector('[data-warren-variants]').textContent);
      const fields = root.querySelector('[data-warren-fields]');
      const usd = n => new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(n);
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:root.dataset.currency || 'USD'}).format(cents/100);
      root.querySelector('[data-warren-base]').textContent = `Transmission base price: ${usd(config.price)} USD + core deposit and selected options.`;
      const fitmentControls = [];
      Object.entries(config.fitment).forEach(([name,values],index) => {
        const label = document.createElement('label'), select = document.createElement('select');
        select.id = `psc-warren-${root.dataset.handle}-${index}`;
        select.required = true; select.dataset.property = name;
        label.htmlFor = select.id; label.textContent = name;
        select.add(new Option(`Select ${name.toLowerCase()}`,''));
        values.forEach(value => select.add(new Option(value,value)));
        fields.append(label,select); fitmentControls.push(select);
      });
      const colors = document.createElement('fieldset'), legend = document.createElement('legend'), row = document.createElement('div');
      legend.textContent = 'Transmission color'; row.className = 'psc-warren__colors'; colors.append(legend,row); fields.append(colors);
      const colorControls = config.colors.map((color,index) => {
        const label=document.createElement('label'), input=document.createElement('input'), swatch=document.createElement('span'), text=document.createElement('span');
        label.className='psc-warren__color'; input.type='radio'; input.name='psc-paint'; input.value=color; input.checked=index===0;
        swatch.className='psc-warren__swatch'; swatch.style.backgroundColor=palette[color]; swatch.setAttribute('aria-hidden','true');
        const extra=config.colorSurcharges[color] || 0;
        text.textContent=color+(config.unpricedColors?.includes(color)?' (paint quote required)':extra?` (+${usd(extra)} USD)`:'');
        label.append(input,swatch,text); row.append(label); return input;
      });
      const addonControls=[];
      if(config.addons.length){
        const addonSet=document.createElement('fieldset'), heading=document.createElement('legend');
        addonSet.className='psc-warren__addons'; heading.textContent='Optional upgrades'; addonSet.append(heading);
        config.addons.forEach((addon,index)=>{
          const label=document.createElement('label'), input=document.createElement('input'), text=document.createElement('span');
          input.type='checkbox'; input.dataset.addon=index;
          text.textContent=`${addon.name} (+${usd(addon.price)} USD)`;
          label.append(input,text); addonSet.append(label); addonControls.push(input);
        });fields.append(addonSet);
      }
      const requested=new URL(location.href).searchParams.get('variant');
      const initial=variants.find(v=>String(v.id)===requested);
      if(initial){colorControls.forEach(c=>c.checked=c.value===initial.options[0]); const pkg=config.packages.find(p=>p.name===initial.options[1]);if(pkg)addonControls.forEach((c,i)=>c.checked=!!(pkg.mask & (1<<i)));}
      let selected;
      function update(){
        const color=colorControls.find(c=>c.checked)?.value || config.colors[0];
        const mask=addonControls.reduce((sum,c,i)=>sum+(c.checked?(1<<i):0),0);
        const pkg=config.packages.find(p=>p.mask===mask);
        selected=variants.find(v=>v.options[0]===color && v.options[1]===pkg.name);
        const hero=root.querySelector('.psc-warren__image'), src=config.images?.[color];
        if(src){hero.removeAttribute('srcset');hero.src=src;hero.alt=`${config.title} — ${color} color preview`;}
        root.querySelector('[data-warren-total]').textContent=selected?money(selected.price):`${usd(config.price+pkg.extra+(config.colorSurcharges[color]||0))} USD`;
        const needsQuote=config.unpricedColors?.includes(color);
        if(needsQuote)root.querySelector('[data-warren-total]').textContent+=' + paint quote';
        button.disabled=needsQuote || !selected || !selected.available;
        button.textContent=needsQuote?'Contact PSC for this color price':!selected?'Contact PSC to order':!selected.available?'Unavailable':'Add to cart';
        if(selected){const url=new URL(location.href);url.searchParams.set('variant',selected.id);history.replaceState({},'',url);}
      }
      form.addEventListener('change',update);update();
      form.addEventListener('submit',async event=>{
        event.preventDefault();if(!form.reportValidity() || !selected?.available || config.unpricedColors?.includes(selected.options[0]))return;
        error.hidden=true;button.disabled=true;button.textContent='Adding…';
        const properties=Object.fromEntries(fitmentControls.map(c=>[c.dataset.property,c.value]));
        properties['Core deposit']='$800 USD included';
        try{
          const added=await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:selected.id,quantity:1,properties}]})});
          const result=await added.json();if(!added.ok)throw new Error(result.description || 'This configuration could not be added. Please try again.');
          location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
        }catch(e){report(e.message);update();}
      });
    }catch(e){report(e.message);}
  }
  document.querySelectorAll('[data-warren-product]').forEach(mount);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-warren-product]').forEach(mount));
})();
